<app-layout>
  <router-outlet />
</app-layout>

<enr-toast-container position="bottom-right"></enr-toast-container>
